import { format } from 'date-fns'
import { request, plannerRequest, requestV3 } from 'Features/Auth/axios-client'
import { useState } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  ImportSnapshotVariables,
  UseImportSnapshotParams,
} from '../ProjectDetails/ProjectDetails.types'
import { useCreateProjectDataParams } from '../ProjectList/ProjectList.types'
import { ProjectParamsInterface } from './CreateProject.types'

const fetchSnapshotList = async () => {
  const { data } = await request({
    url: `/snapshots`,
  })
  return data
}

export const useSnapshotData = () => {
  return useQuery({
    queryKey: ['snapshots'],
    queryFn: fetchSnapshotList,
    select: (data) => data.data,
    refetchOnWindowFocus: false,
  })
}

const createSnapshot = async ({
  snapshotName,
  endDate,
  snapshotLength,
  projectId,
  projectUserId,
}: ImportSnapshotVariables) => {
  const dateString = format(endDate, 'yyyyMMdd')
  const { data } = await request({
    url: `/snapshots`,
    method: 'post',
    data: {
      projectId,
      projectUserId,
      dataSnapshotName: snapshotName,
      snapshotEndDate: dateString,
      snapshotLength: snapshotLength,
    },
  })
  return data
}

const fetchImportSnapshotStatus = async (snapshotId: string | null) => {
  if (!snapshotId) {
    return
  }
  const { data } = await request({
    url: `/snapshots/${snapshotId}/status`,
  })
  return data
}

// /source-sites GET API call using plannerRequest
const fetchSourceSites = async () => {
  const { data } = await plannerRequest({
    url: `/source-sites`,
  })
  return data
}

export const useSourceSites = () => {
  return useQuery({
    queryKey: ['source-sites'],
    queryFn: fetchSourceSites,
    select: (data) => data.data,
    refetchOnWindowFocus: false,
  })
}
// /source-sites GET API call using plannerRequest

const createProject = async (projectData: ProjectParamsInterface) => {
  const { data } = await requestV3({
    url: `/projects`,
    method: 'post',
    data: projectData,
  })
  return data
}

export const useCreateProjectData = ({
  onCreateProjectSuccess,
}: useCreateProjectDataParams) => {
  return useMutation({
    mutationFn: createProject,
    onSuccess: ({ data, message }) => {
      onCreateProjectSuccess(data.id, message)
    },
  })
}
